import { ResultsItem, ResultSubItem, IconContent } from '../../../features/Report';
import { Tooltip, Table, CopyButton } from '../../../components';

export const DomainSection = ({ id, data }) => {
  const defaultCriteria = {
    status: 'info',
    iconType: 'info',
    importance: { level: 0, text: '' },
    solvability: { level: 0, text: '' },
    isEmpty: true,
    message: 'Data is unavailable.',
    data: null,
  };

  const domainRegistration = data?.domainRegistration || defaultCriteria;
  const domainAvailability = data?.domainAvailability || defaultCriteria;
  const typoAvailability = data?.typoAvailability || defaultCriteria;
  const errorCount = data?.errorCount || 0;
  const toImproveCount = data?.toImproveCount || 0;

  const domainAvailabilityRows = domainAvailability?.data?.rows || [];
  const typoAvailabilityRows = typoAvailability?.data?.rows || [];

  const domainAvailabilityTableData = domainAvailabilityRows.length > 0
    ? [
        ['Domains', 'Status'],
        ...domainAvailabilityRows.map((r) => [r?.domain || '', r?.statusText || '']),
      ]
    : [['Domains', 'Status']];

  const typoAvailabilityTableData = typoAvailabilityRows.length > 0
    ? [
        ['Domains', 'Status'],
        ...typoAvailabilityRows.map((r) => [r?.domain || '', r?.statusText || '']),
      ]
    : [['Domains', 'Status']];

  return (
    <ResultsItem 
      id={id}
      title="Domain" 
      tooltip="Your domain is one of the most important parts of your website. It should be short, concise, and mention your brand name if possible. Try not to include numbers, underscores, or random letters as it can make your domain hard for Google (and users) to understand and remember."
      errorCount={errorCount}
      toImproveCount={toImproveCount}
    >
      <ResultSubItem
        title="Domain Registration"
        tooltip="When your domain was created and when it expires."
        content={
          <IconContent
            icon={
              <Tooltip 
                iconType={domainRegistration?.iconType || 'info'} 
                showTooltip={false} 
              />
            }
          >
            {!domainRegistration?.isEmpty && (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <p className="text-primary">
                  <span className="text-strong">{domainRegistration?.data?.createdText || ''}</span>
                </p>
                <p className="text-secondary">
                  {domainRegistration?.data?.expiresText || ''}
                </p>
              </div>
            )}
            
            {domainRegistration?.isEmpty && (
              <p className="text-primary">
                {domainRegistration?.message || 'The info related to the Domain Registration was not found.'}
              </p>
            )}
          </IconContent>
        }
      />

      <ResultSubItem
        title="Domain Availability"
        tooltip="Similar domains to the one you own and their status."
        content={
          <IconContent
            icon={
              <Tooltip 
                iconType={domainAvailability?.iconType || 'info'} 
                showTooltip={false} 
              />
            }
          >
            {!domainAvailability?.isEmpty && (
              <div className="table-content-wrapper">
                <Table
                  data={domainAvailabilityTableData}
                  className="table-domain-status"
                  id="domain-availability-table"
                />
                <div className="copy-button-wrapper">
                  <CopyButton targetSelector="#domain-availability-table" />
                </div>
              </div>
            )}
            
            {domainAvailability?.isEmpty && (
              <p className="text-primary">{domainAvailability?.message || 'No domains were found.'}</p>
            )}
          </IconContent>
        }
      />

      <ResultSubItem
        title="Typo Availability"
        tooltip="Similar domains that seem to have a typo and their availability."
        content={
          <IconContent
            icon={
              <Tooltip 
                iconType={typoAvailability?.iconType || 'info'} 
                showTooltip={false} 
              />
            }
          >
            {!typoAvailability?.isEmpty && (
              <div className="table-content-wrapper">
                <Table
                  data={typoAvailabilityTableData}
                  className="table-domain-status"
                  id="typo-availability-table"
                />
                <div className="copy-button-wrapper">
                  <CopyButton targetSelector="#typo-availability-table" />
                </div>
              </div>
            )}
            
            {typoAvailability?.isEmpty && (
              <p className="text-primary">{typoAvailability?.message || 'No domains were found.'}</p>
            )}
          </IconContent>
        }
      />
    </ResultsItem>
  );
};
